<div class="flex-container">
    <app-header [title]="'Draft ' + reportName + ' report'" [details]="{ reportStatus: 'DRAFT' }" [showHomeButton]="true" [showTitle]="true"> </app-header>
    <div class="container-fluid address-container mt-3">
        <div class="card col-lg-4 col-md-4 col-sm-12">
            <div class="card-header bg-blue-grey-400">
                Create {{reportName}} report 
            </div>
            <div class="card-body">
                <div class="address-screen">
                    <div class="address-block">
                        <div>
                            <label class="form-label">Country <span class="required">*</span></label>
                            <select class="form-select" [(ngModel)]="countryCode" [ngModelOptions]="{standalone: true}" name="country">
                                <option value=""></option>
                                <option *ngFor="let country of countryCodes" [value]="country.code">{{ country.name }}</option>
                            </select>
                        </div>
                        <div class="mt-2">
                            <label class="form-label">Postcode <span class="required">*</span></label>
                            <input type="text" class="form-control" [(ngModel)]="postcode" [ngModelOptions]="{standalone: true}" name="postcode" /> 
                        </div>
                        <div class="mt-2 btns-row">
                            <button class="btn btn-primary" (click)="lookupAddress()">Lookup address</button>
                            <button class="btn btn-primary" (click)="enterManuallyAddress($event.target)">Enter manually</button>
                        </div>
                        <div class="mt-2" *ngIf="addresses?.length">
                            <label class="form-label">Select Address</label>
                            <select class="form-select" [(ngModel)]="selectedAddress" [ngModelOptions]="{standalone: true}" (ngModelChange)="onSelectAddress($event)">
                                <option value=""></option>
                                <option *ngFor="let address of addresses" [ngValue]="address">{{ address.addressLine }}</option>
                            </select>
                        </div>
                        <div class="mt-2">
                            <label class="form-label">Address line 1</label>
                            <input type="text" class="form-control" [disabled]="isDisabled" [ngModelOptions]="{standalone: true}" [(ngModel)]="addressDetails.address1" />
                        </div>
                        <div class="mt-2" *ngIf="addressDetails.address2 || isManual">
                            <label class="form-label">Address line 2</label>
                            <input type="text" class="form-control" [disabled]="isDisabled" [ngModelOptions]="{standalone: true}" [(ngModel)]="addressDetails.address2" />
                        </div>
                        <div class="mt-2" *ngIf="addressDetails.address3 || isManual">
                            <label class="form-label">Address line 3</label>
                            <input type="text" class="form-control" [disabled]="isDisabled" [ngModelOptions]="{standalone: true}" [(ngModel)]="addressDetails.address3" />
                        </div>
                        <div class="mt-2" *ngIf="addressDetails.address4 || isManual">
                            <label class="form-label">Address line 4</label>
                            <input type="text" class="form-control" [disabled]="isDisabled" [ngModelOptions]="{standalone: true}" [(ngModel)]="addressDetails.address4" />
                        </div>
                        <div class="mt-2">
                            <label class="form-label">Town</label>
                            <input type="text" class="form-control" [disabled]="isDisabled" [ngModelOptions]="{standalone: true}" [(ngModel)]="addressDetails.town" />
                        </div>
                        <div class="mt-2">
                            <label class="form-label">UPRN</label>
                            <input type="text" class="form-control" [disabled]="isDisabled" [ngModelOptions]="{standalone: true}" [(ngModel)]="addressDetails.uprn" />
                        </div>
                    </div>
                    <div class="mt-3 assessment-date-block">
                        <div>
                            <label class="form-label">Assessment date <span class="required">*</span></label>
                            <input type="date"[(ngModel)]="assessmentDate" [ngModelOptions]="{standalone: true}" class="form-control" />
                        </div>
                    </div>
                    <div class="mt-2 btns-row">
                        <button class="btn btn-primary">Create</button>
                        <!-- <button type="button" class="btn btn-secondary">Cancel</button> -->
                    </div>
                </div>
            </div>
        </div>
    </div>
    <app-footer class="mt-3"></app-footer>
</div>